<div class="informate_select_wrapper" [formGroup]="form">
    <!-- <mat-label class="mat-label-general" #tooltip="matTooltip" matTooltip="Standard" [matTooltipPosition]="tooltip_position" i18n>Standard</mat-label> -->
    <mat-label class="mat-label-general" placement="right" container="body" tooltipClass="custom-tooltip" [ngbTooltip]="standard_tooltip">
        <!-- Standard -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.STANDARD' | transloco }}
    </mat-label>
    <ng-template #standard_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.STANDARD' | transloco }}
        </p>
    </ng-template>

    <mat-select
        *ngIf="!isCustom"
        formControlName="standard"
        name="standard"
        class="mat-select-general input-form-class"
        [class.spinner]="loading"
        (selectionChange)="selectStandard($event)"
        [class.select-disable]="enable"
    >
        <mat-option class="option-list" *ngFor="let sl of standardList" [value]="sl.standardId">{{ sl.standardName }}</mat-option>
    </mat-select>
</div>
<input *ngIf="isCustom" class="input-form-class" matInput formControlName="customStandardName" name="customStandardName" />
